import type { AnyModel } from '../populateLayouts/types/models';
import { ModelType } from '../populateLayouts/types/models';
import type { AllProps } from '../../propsMixin/props';
import { mapBlendMode } from '../populateLayouts/mapBlendMode';

/* eslint-disable @typescript-eslint/no-explicit-any */
export function layoutModelToProps(model: AnyModel<any>): AllProps {
  const out: AllProps = {
    x: model.x,
    y: model.y,
    scaleX: model.scale.x,
    scaleY: model.scale.y,
    angle: model.angle,
    alpha: model.alpha,
    visible: model.visible,
    // TODO handle interactivity
  };

  if (model.type === ModelType.Sprite) {
    out.anchorX = model.anchor.x;
    out.anchorY = model.anchor.y;
    out.tint = model.tint;
    out.blendMode = mapBlendMode(model.blendMode);
    out.texture = model.texture;
  }

  if (model.type !== ModelType.Container && model.type !== ModelType.Sprite) {
    console.warn('layoutModelToProps supports only sprite specific props');
  }

  return out;
}
